import React from "react";
import Icons from "../../assets/svg/sprite.svg";

export default ({ icon, className, iconFill, iconStroke, iconSize }) => (
  <svg
    className={`afs-msm-icon ${className || ""}`}
    fill={iconFill}
    stroke={iconStroke}
    width={iconSize}
    height={iconSize}
  >
    <use xlinkHref={`${Icons}#${icon}`} />
  </svg>
);
